import React from 'react';
import { cn } from '@/shared/utils/cn';
import { ListItemDefault } from '@/modules/Lists';
import { Icon } from '@/modules/Icon';
import { Badge } from '@/modules/Badge';
import { SidebarMenuItemProps } from '../../types';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons';

/**
 * ============================================
 * SIDEBAR MENU ITEM - ATOM
 * ============================================
 * Componente atómico para items individuales del menú lateral.
 * Reutiliza el componente ListItemDefault del paquete UI.
 *
 * Soporta iconos, badges, estados activo/deshabilitado y submenús.
 */
export const SidebarMenuItem: React.FC<SidebarMenuItemProps> = ({
  id,
  label,
  icon,
  badge,
  active = false,
  disabled = false,
  hasSubmenu = false,
  onClick,
  className,
}) => {
  const handleClick = (e: React.MouseEvent) => {
    if (!disabled) {
      onClick?.(id);
    }
  };

  return (
    <ListItemDefault
      icon={icon}
      current={active}
      disabled={disabled}
      onClick={handleClick}
      className={cn('ui-h-32', className)}
    >
      {/* Label */}
      <span className="ui-flex-1 ui-truncate">{label}</span>

      {/* Badge */}
      {badge && (
        <Badge
          label={String(badge.label)}
          color={badge.color || 'accent'}
          theme={badge.theme || 'solid'}
          size="sm"
        />
      )}

      {/* Chevron para submenú */}
      {hasSubmenu && (
        <Icon name={faChevronRight} size="md" color="tertiary" className="ui-shrink-0" />
      )}
    </ListItemDefault>
  );
};
